export default "__VITE_ASSET__2e1b4cec__"